module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921111149_T.3b0cbfa5.jpg";